<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <gg-toolbar @close="close">
        Set MySQL User Password
      </gg-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <p>Set a new password for user "{{ user.user }}".</p>
          </v-col>
        </v-row>
        <compact-password
          cpanel-app="mysql"
          show-strength
          outlined
          label="New Password"
          v-validate="'required'"
          data-vv-name="password"
          data-vv-as="New Password"
          :error-messages="errors.collect('password')"
          with-generator
          v-model="password"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <gg-btn @click="close" secondary>Cancel</gg-btn>
        <gg-btn
          :loading="loading"
          @click="changePassword"
        >
          Change Password
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'RenameUserModal',
  components: {
    CompactPassword
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      loading: false,
      password: ''
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    }
  },
  methods: {
    ...mapActions({
      changeMysqlUserPassword: 'mysql/changeMysqlUserPassword',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    listenPassword (payload) {
      this.password = payload
    },
    reset () {
      this.password = ''
      this.$refs.password.clearPassword()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    close () {
      this.$emit('close')
    },
    async changePassword () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      try {
        await this.changeMysqlUserPassword({
          user: this.user.user,
          password: this.password,
          _username: this.$route.query.user,
        })
        this.reportSuccess(`You have successfully set “${this.user.user}”’s password.`)
        this.$emit('action-completed', 'user-password-changed')
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
    }
  }
}
</script>
